import Axios from 'axios'
import * as htmlToImage from 'html-to-image'
import {v4 as uuidv4} from 'uuid'
import {IAppStore} from '../../../interfaces/reducers'
import ExportMapActions from '../../enums/ActionTypes/ExportMapActions'
import MapActions from '../../enums/ActionTypes/MapActions'
import {setStyleScale} from '../../helpers'
import {IActionDispatcher, IExportMapDispatcher, IPaylodAction} from '../../interfaces/dispatchers'
import {IFeatureLayerInfo, IRenderImageInfo, PageSize} from '../../interfaces/models'
import {IExportElement, IExportJob, IExportLayouts, IExportMap, IStore} from '../../interfaces/reducers'
import {Extent, Feature, Fill, Point, Style, Text, VectorLayer} from '../../models'
import {config} from '../../reducers/config'
import {getMapService} from '../../reducers/map'
import {MapService} from '../../services'
import {PdfCalculator} from './PdfCalculator'
import VectorSource from 'ol/source/Vector'

export class ExportMapDispatcher implements IExportMapDispatcher {
  pdfCalculator?: PdfCalculator
  constructor() {
    this.setScale = this.setScale.bind(this)
    this.setExtent = this.setExtent.bind(this)
    this.startJob = this.startJob.bind(this)
    this.setPageSize = this.setPageSize.bind(this)
    this.setDPI = this.setDPI.bind(this)
    this.setPreviewMode = this.setPreviewMode.bind(this)
    this.setPaper = this.setPaper.bind(this)
    this.setMapDivProps = this.setMapDivProps.bind(this)
    this.setMargins = this.setMargins.bind(this)
    this.updateElementProps = this.updateElementProps.bind(this)
    this.setLayouts = this.setLayouts.bind(this)
    this.setZoomFactor = this.setZoomFactor.bind(this)
    this.setFeatures = this.setFeatures.bind(this)
    this.useBackground = this.useBackground.bind(this)
    this.setEditMode = this.setEditMode.bind(this)
  }
  public setDPI(dpi: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch({
        type: ExportMapActions.SET_DPI,
        payload: dpi
      })
      const ex = getStore().map.mapService.getExtent()
      if (this.pdfCalculator) {
        this.pdfCalculator.changeDpi(dpi)
        const exportMapStore = getStore().exportMap

        this.onLayoutChange(dispatch, false)
        dispatch({
          type: ExportMapActions.SET_MAP_PROPS,
          payload: {
            ...exportMapStore.mapProps,
            prefferedMapPixelWh: this.pdfCalculator.getPixelsFromExtent(ex, exportMapStore.mapProps.scale),
            mapPaparWh: this.pdfCalculator.getMilimetersFromExtent(ex, exportMapStore.mapProps.scale)
          }
        })
      }
    }
  }

  public setScale(scale: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const scaleChange = scale / getStore().exportMap.mapProps.scale
      dispatch({
        type: ExportMapActions.SET_MAP_PROPS,
        payload: {
          ...getStore().exportMap.mapProps,
          scale: scale
        }
      })
      setTimeout(() => {
        const mMan = getStore().map.mapService as MapService
        const currentExtent = mMan.getExtent().clone()
        const currentWidth = currentExtent.getWidth()
        const currentHeight = currentExtent.getHeight()
        const halfWidthChange = (currentWidth - currentWidth * scaleChange) / 2
        const halfHeightChange = (currentHeight - currentHeight * scaleChange) / 2
        currentExtent.setXMax(currentExtent.getXMax() - halfWidthChange)
        currentExtent.setXMin(currentExtent.getXMin() + halfWidthChange)

        currentExtent.setYMax(currentExtent.getYMax() - halfHeightChange)
        currentExtent.setYMin(currentExtent.getYMin() + halfHeightChange)

        mMan.map.getView().setResolution(mMan.map.getView().getResolutionForExtent(currentExtent.getExtent()))
      }, 100)
    }
  }

  public setMapDivProps(resizibleWidth: number, resizibleHeight: number, resizibleLeft: number, resizibleTop: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const exportMapStore = getStore().exportMap
      dispatch({
        type: ExportMapActions.SET_MAP_PROPS,
        payload: {
          ...exportMapStore.mapProps,
          resizibleWidth,
          resizibleHeight,
          resizibleLeft,
          resizibleTop
        }
      })
    }
  }
  paper: HTMLDivElement | undefined
  setPaper(paper?: HTMLDivElement) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      this.paper = paper
    }
  }

  public updateElementProps(key: string, elementProps?: IExportElement) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const payload = getStore().exportMap.elements
      if (!elementProps) {
        delete payload[key]
      } else {
        payload[key] = elementProps
      }

      dispatch({
        type: ExportMapActions.SET_ELEMENT_PROPS,
        payload: payload
      })
    }
  }

  public useBackground(value: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch({
        type: ExportMapActions.SET_USE_BACKGROUND,
        payload: value
      })
    }
  }
  editMode = false
  rawLayouts: IExportLayouts | null = null
  lastSelectedParcel: Feature | undefined = undefined
  lastAdditionalData: string | undefined = undefined

  private applyLayoutElements(
    dispatch: (data: IPaylodAction | IActionDispatcher) => void,
    exportMapStore: IExportMap,
    layouts: IExportLayouts
  ) {
    const layout = layouts[exportMapStore.pageSize]
    if (layout) {
      const orientedLayout = exportMapStore.landscape ? layout.landscape : layout.portrait
      dispatch({
        type: ExportMapActions.SET_ELEMENT_PROPS,
        payload: {...orientedLayout.elements}
      })
    }
  }

  private renderLayouts(
    layouts: IExportLayouts,
    user: any,
    selectedParcel?: Feature,
    additionalData?: string
  ): IExportLayouts {
    const rendered: IExportLayouts = JSON.parse(JSON.stringify(layouts))
    for (const l in rendered) {
      for (const orient of ['landscape', 'portrait'] as const) {
        for (const el in rendered[l][orient].elements) {
          if (rendered[l][orient].elements[el].text) {
            rendered[l][orient].elements[el].text = rendered[l][orient].elements[el]
              .text!.replace(/{username}/g, user.Name || user.username)
              .replace(
                /{date}/g,
                new Date().getDate() + ' ' + this.getMounth() + ' ' + new Date().getFullYear().toString() + ' г.'
              )
              .replace(/{AdditionalData}/g, additionalData || '')
              .replace(/{Coordinates}/g, additionalData || '')
            if (selectedParcel) {
              for (const prop in selectedParcel.getProperties()) {
                if (prop == 'PlanDate') {
                  const temp = selectedParcel.getProperties()['PlanDate'].split('T')[0].split('-')
                  const newdate = temp[2] + '.' + temp[1] + '.' + temp[0] + 'г.'
                  rendered[l][orient].elements[el].text = rendered[l][orient].elements[el].text!.replace(
                    new RegExp(`{${prop}}`, 'g'),
                    newdate + ' г.'
                  )
                }
                rendered[l][orient].elements[el].text = rendered[l][orient].elements[el].text!.replace(
                  new RegExp(`{${prop}}`, 'g'),
                  selectedParcel.getProperties()[prop] || 'Няма данни'
                )
              }
            }
          }
        }
      }
    }
    return rendered
  }

  public setEditMode(value: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      this.editMode = value
      dispatch({
        type: ExportMapActions.SET_EDIT_MODE,
        payload: value
      })
      if (!this.rawLayouts) return
      const exportMapStore = getStore().exportMap
      if (value) {
        this.applyLayoutElements(dispatch, exportMapStore, this.rawLayouts)
      } else {
        const user = (getStore() as any).userInfo.user!
        const rendered = this.renderLayouts(this.rawLayouts, user, this.lastSelectedParcel, this.lastAdditionalData)
        this.applyLayoutElements(dispatch, exportMapStore, rendered)
      }
    }
  }

  protected getPromises(exportMapStore: IExportMap): Array<Promise<IRenderImageInfo>> {
    const extent = getMapService().getExtent()
    const renderImageInfosPromises: Array<Promise<IRenderImageInfo>> = []
    renderImageInfosPromises.push(
      new Promise((resolve, reject) => {
        getMapService()
          .export()
          .then((r: Blob) => {
            resolve({
              Page: 1,
              MapProps: {
                Top: this.pdfCalculator!.pixelsToUnits(exportMapStore.mapProps.resizibleTop * exportMapStore.dpiFactor),
                Left: this.pdfCalculator!.pixelsToUnits(
                  exportMapStore.mapProps.resizibleLeft * exportMapStore.dpiFactor
                ),
                WidthMeters: extent.getGeodeticWidth(),
                HeightMeters: extent.getGeodeticHeight(),
                TargetScale: exportMapStore.mapProps.scale
              },
              ZIndex: 2,
              Blob: r
            })
          })
          .catch((e: Error) => {
            reject(e)
          })
      })
    )
    if (exportMapStore.useBackground) {
      renderImageInfosPromises.push(
        new Promise((resolve, reject) => {
          getMapService()
            .getBasemapLayers()
            .forEach(l => {
              l.setVisible(true)
            })
          htmlToImage
            .toBlob(this.paper!, {
              width: exportMapStore.defaultLayoutWidth + 1,
              height: exportMapStore.defaultLayoutHeight + 1,
              style: {
                boxSizing: 'border-box'
              }
            })
            .then((r: Blob) => {
              resolve({
                Page: 1,
                ZIndex: 1,
                Blob: r
              })
            })
            .catch((e: Error) => {
              reject(e)
            })
        })
      )
    }

    renderImageInfosPromises.push(
      new Promise((resolve, reject) => {
        htmlToImage
          .toBlob(this.paper!, {
            width: exportMapStore.defaultLayoutWidth + 1,
            height: exportMapStore.defaultLayoutHeight + 1,
            style: {
              boxSizing: 'border-box'
            }
          })
          .then((r: Blob) => {
            resolve({
              Page: 1,
              ZIndex: 1,
              Blob: r
            })
          })
          .catch((e: Error) => {
            reject(e)
          })
      })
    )
    return renderImageInfosPromises
  }
  protected restoreMap(zoom: number, point: number[]): Promise<void> {
    return new Promise((resolve, reject) => {
      const mMan = getMapService() as MapService
      const layers = mMan.getBasemapLayers()

      // remove temporary overlay layer
      mMan.getLayers().forEach(layer => {
        if (layer.moreInfo.guid == 'temporary-overlay') {
          mMan.removeLayer(layer)
        }
      })

      for (let i = 0; i < layers.length; i++) {
        const layer = layers[i]
        layer.setVisible(true)
      }
      setStyleScale(1)
      mMan.setCenter(point)
      mMan.setZoom(zoom)
      mMan.mapDiv.style.height = '100%'
      mMan.mapDiv.style.width = '100%'
      mMan.updateSize()

      const f = new Feature()
      f.setGeometry(mMan.getExtent().getPolygon())

      setTimeout(() => {
        resolve()
      }, 200)
    })
  }

  public setFeatures(features: {layerInfo: IFeatureLayerInfo; features: Feature[]}[]) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch({
        type: ExportMapActions.SET_FEATURES,
        payload: features
      })
    }
  }
  extentChangeBlocked = false
  protected hackMap(exportMapStore: IExportMap): Promise<void> {
    return new Promise((resolve, reject) => {
      this.extentChangeBlocked = true
      const mMan = getMapService() as MapService
      setStyleScale(exportMapStore.dpiFactor)

      // add temporary overlay layer because when we export as image the overlay element is not added, because it is a DOM element, not part of the map canvas
      const overlays = mMan.map.getOverlays().getArray()

      const overlayFeatures = overlays.map(overlay => {
        const overlayText = overlay?.getElement()?.innerHTML || ''
        return new Feature({
          geometry: new Point(overlay?.getPosition() || []),
          name: 'Overlay',
          overlayText
        })
      })

      const source = new VectorSource({
        features: overlayFeatures as any
      })

      const vectorLayer = new VectorLayer({
        source,
        style: feature => {
          const properties = feature.getProperties()
          const meters = properties.overlayText.split(' ')[0]

          return new Style({
            text: new Text({
              text: `${meters} м2`,
              font: 'bold 40px sans-serif',
              fill: new Fill({
                color: 'rgba(255, 0, 0, 0.75)'
              })
            })
          })
        }
      })
      vectorLayer.moreInfo = {
        urls: ['temporary-overlay'],
        guid: 'temporary-overlay',
        type: 'regular',
        refreshOnExtentChange: false,
        isActive: true
      }

      mMan.addLayer(vectorLayer)

      const layers = mMan.getBasemapLayers()
      for (let i = 0; i < layers.length; i++) {
        const layer = layers[i]
        layer.setVisible(false)
      }

      const extentClone = getMapService().getExtent().clone()
      const cacheCenter = extentClone.getCenter().getCoordinates()
      mMan.mapDiv.style.height = `${exportMapStore.mapProps.prefferedMapPixelWh[1]}px`
      mMan.mapDiv.style.width = `${exportMapStore.mapProps.prefferedMapPixelWh[0]}px`
      mMan.setZoom(20)
      setTimeout(() => {
        mMan.map.getView().setResolution(mMan.map.getView().getResolutionForExtent(extentClone.getExtent()))
        mMan.setCenter(cacheCenter)
        mMan.updateSize()
        mMan.map.renderSync()
        setTimeout(() => {
          this.extentChangeBlocked = false
          resolve()
        }, 500)
      }, 1000)
    })
  }

  public setMargins(margins: [number, number, number, number]) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      if (this.pdfCalculator) {
        this.pdfCalculator.changeMargins(margins)
        this.onLayoutChange(dispatch, false)
        dispatch({
          type: ExportMapActions.SET_MARGINS,
          payload: margins
        })
      }
    }
  }

  protected onLayoutChange(dispatch: (data: IPaylodAction | IActionDispatcher) => void, applyLayout: boolean) {
    if (this.pdfCalculator) {
      dispatch({
        type: ExportMapActions.SET_LAYOUT_WH,
        payload: this.pdfCalculator.getWidthAndHeight()
      })

      dispatch({
        type: ExportMapActions.SET_PIXEL_TO_UNIT_FACTOR,
        payload: this.pdfCalculator.getPixelsToUnitsFactor()
      })
      dispatch({
        type: ExportMapActions.SET_PIXEL_TO_MM_FACTOR,
        payload: this.pdfCalculator.getPixelsToMMFactor()
      })
      dispatch({
        type: ExportMapActions.SET_NON_MARGIN_PAPER_WH_MM,
        payload: [this.pdfCalculator.getCanvasWidthMM(), this.pdfCalculator.getCanvasHeightMM()]
      })
    }

    setTimeout(() => {
      if (applyLayout) {
        dispatch(this.setLayouts(true))
      }
      getMapService().updateSize()
    }, 100)
  }

  public setExtent(extent: Extent) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const exportMapStore = getStore().exportMap
      if (!this.pdfCalculator) {
        this.pdfCalculator = new PdfCalculator(
          exportMapStore.pageSize,
          exportMapStore.margins,
          exportMapStore.dpi,
          exportMapStore.landscape
        )
        this.onLayoutChange(dispatch, Object.keys(exportMapStore.layouts).length == 0) // this executes once
      }

      const mm = getStore().map.mapService as MapService
      if (mm && !this.extentChangeBlocked) {
        const ex = mm.getExtent()
        let scale = this.pdfCalculator.getScaleFromExtent(ex, [mm.getWidth(), mm.getHeight()])
        if (Math.abs(scale - exportMapStore.mapProps.scale) < 3) {
          scale = exportMapStore.mapProps.scale
        }
        dispatch({
          type: ExportMapActions.SET_MAP_PROPS,
          payload: {
            ...exportMapStore.mapProps,
            prefferedMapPixelWh: this.pdfCalculator.getPixelsFromExtent(ex, scale),
            scale: scale,
            mapPaparWh: this.pdfCalculator.getMilimetersFromExtent(extent, scale)
          }
        })
      }
    }
  }

  public setZoomFactor(zoomFactor: number) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch({
        type: ExportMapActions.SET_ZOOM_FACTOR,
        payload: zoomFactor
      })
    }
  }

  public getMounth() {
    const mount = new Date().getMonth() + 1
    switch (mount) {
      case 1:
        return 'Януари'
      case 2:
        return 'Февруари'
      case 3:
        return 'Март'
      case 4:
        return 'Април'
      case 5:
        return 'Май'
      case 6:
        return 'Юни'
      case 7:
        return 'Юли'
      case 8:
        return 'Август'
      case 9:
        return 'Септември'
      case 10:
        return 'Октомври'
      case 11:
        return 'Ноември'
      default:
        return 'Декември'
    }
  }

  public setLayouts(
    applyCurrent: boolean,
    layouts?: IExportLayouts,
    selectedParcel?: Feature,
    additionalData?: string
  ) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
      const user = getStore().userInfo.user!
      if (layouts && !this.editMode) {
        this.rawLayouts = JSON.parse(JSON.stringify(layouts))
        this.lastSelectedParcel = selectedParcel
        this.lastAdditionalData = additionalData
        layouts = this.renderLayouts(layouts, user, selectedParcel, additionalData)
      }
      const exportMapStore = getStore().exportMap
      layouts = layouts
        ? layouts
        : Object.keys(exportMapStore.layouts).length == 0
          ? config.getConfig().layouts
          : exportMapStore.layouts
      dispatch({
        type: ExportMapActions.SET_LAYOUTS,
        payload: layouts
      })
      if (applyCurrent) {
        const layout = layouts[exportMapStore.pageSize]
        if (layout) {
          const orientedLayout = exportMapStore.landscape ? layout.landscape : layout.portrait
          dispatch({
            type: ExportMapActions.SET_MAP_PROPS,
            payload: {...exportMapStore.mapProps, ...orientedLayout.mapProps}
          })
          dispatch({
            type: ExportMapActions.SET_ZOOM_FACTOR,
            payload: orientedLayout.zoomFactor
          })
          dispatch({
            type: ExportMapActions.SET_MARGINS,
            payload: orientedLayout.margins
          })
          dispatch({
            type: ExportMapActions.SET_ELEMENT_PROPS,
            payload: orientedLayout.elements
          })
        }
      }
    }
  }

  public setPageSize(pageSize: PageSize, landscape: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      this.pdfCalculator!.changePageSize(pageSize, landscape)
      dispatch({
        type: ExportMapActions.SET_PAGE_SIZE,
        payload: pageSize
      })
      dispatch({
        type: ExportMapActions.SET_LANDSCAPE,
        payload: landscape
      })
      setTimeout(() => {
        this.onLayoutChange(dispatch, true)
      }, 100)
    }
  }

  public setPreviewMode(previewMode: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      dispatch({
        type: ExportMapActions.SET_PREVIEW_MODE,
        payload: previewMode
      })
    }
  }

  getVisibleImageLayers(getStore: () => IStore): IRenderImageInfo[] {
    const exportMapStore = getStore().exportMap
    const extent = getMapService().getExtent()
    const result: IRenderImageInfo[] = []
    const mMan = getMapService() as MapService
    mMan.getLayers().forEach(l => {
      let isKais = false
      l.moreInfo.urls.forEach(u => {
        if (u.indexOf('MapAccess_') != -1) {
          isKais = true
        }
      })
      let visible = true
      if (isKais) {
        if ((l as any).getSource().getParams().LAYERS == '') {
          visible = false
        }
      }
      if (
        l.getVisible() &&
        mMan.getResolution()! < l.getMaxResolution() &&
        mMan.getResolution()! > l.getMinResolution() &&
        !(l instanceof VectorLayer) &&
        visible
      ) {
        const infos: IFeatureLayerInfo[] = []
        for (const id in getStore().layerInfos.featureLayerInfos) {
          if (l.moreInfo.urls.indexOf(id) != -1) {
            infos.push(getStore().layerInfos.featureLayerInfos[id])
          }
        }
        infos.forEach(info => {
          result.push({
            MapProps: {
              Top: this.pdfCalculator!.pixelsToUnits(exportMapStore.mapProps.resizibleTop * exportMapStore.dpiFactor),
              Left: this.pdfCalculator!.pixelsToUnits(exportMapStore.mapProps.resizibleLeft * exportMapStore.dpiFactor),
              ProxySettings: {
                Type: info.sourceDescription.serviceType,
                Url: info.sourceDescription.namespacedUrl,
                UrlParams: {
                  Width: mMan.getWidth(),
                  Height: mMan.getHeight(),
                  DPI: exportMapStore.dpiFactor * 90,
                  Xmin: mMan.getExtent().getXMin(),
                  Ymin: mMan.getExtent().getYMin(),
                  Xmax: mMan.getExtent().getXMax(),
                  Ymax: mMan.getExtent().getYMax(),
                  Layers: info.sourceDescription.layerName
                }
              },
              WidthMeters: extent.getGeodeticWidth(),
              HeightMeters: extent.getGeodeticHeight(),
              TargetScale: exportMapStore.mapProps.scale
            },
            Page: 1,
            ZIndex: info.sourceDescription.z
          })
        })
      }
    })
    return result
  }

  getPaperImages(
    getStore: () => IStore,
    mapZoomCache: number,
    mapCenterCache: number[],
    formData: FormData
  ): Promise<IRenderImageInfo[]> {
    return new Promise((resolve, reject) => {
      const exportMapStore = getStore().exportMap
      this.hackMap(exportMapStore).then(() => {
        Promise.all(this.getPromises(exportMapStore))
          .then(renderImageInfos => {
            renderImageInfos = renderImageInfos.concat(this.getVisibleImageLayers(getStore))
            this.restoreMap(mapZoomCache, mapCenterCache)
            resolve(renderImageInfos)
          })
          .catch(e => {
            reject(e)
          })
      })
    })
  }

  public startJob(name: string, hackCallback: (error: string) => void) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {
      const formData = new FormData()
      dispatch({
        type: MapActions.SET_HARD_LOADING,
        payload: true
      })
      const exportMapStore = getStore().exportMap
      const mapZoomCache = getMapService().getZoom()
      const mapCenterCache = getMapService().getCenter()
      this.getPaperImages(getStore, mapZoomCache, mapCenterCache, formData)
        .then(renderImageInfos => {
          dispatch({
            type: MapActions.SET_HARD_LOADING,
            payload: false
          })
          hackCallback('')
          const job: IExportJob = {
            name: name,
            loading: true,
            dateCreated: new Date(),
            url: ''
          }
          const jobGuid = uuidv4()
          const payload: {[guid: string]: IExportJob} = {}
          payload[jobGuid] = job
          dispatch({
            type: ExportMapActions.START_JOB,
            payload: payload
          })

          const meta: {
            [key: string]: IRenderImageInfo
          } = {}

          renderImageInfos.forEach((b, i) => {
            if (b.Blob) {
              formData.append('Files', b.Blob, `${i}`)
            }
            meta[i] = b
          })
          formData.append('Meta', JSON.stringify(meta))
          formData.append('Name', JSON.stringify(name))
          formData.append('PageSize', JSON.stringify(exportMapStore.pageSize))
          formData.append('Margins', exportMapStore.margins.map(m => m.toFixed(0)).join(','))
          formData.append('Landscape', JSON.stringify(exportMapStore.landscape))
          Axios.post(`${config.getConfig().urls.printServiceUrl}`, formData, {
            headers: {'Content-Type': `multipart/form-data;`}
          })
            .then(response => {
              const payloadUpdate = {...payload}
              payloadUpdate[jobGuid].loading = false
              payloadUpdate[jobGuid].url = config.getConfig().urls.printResultsUrl + '/' + response.data
              dispatch({
                type: ExportMapActions.START_JOB,
                payload: payloadUpdate
              })
            })
            .catch(e => {
              console.error(e)
              const payloadUpdate = {...payload}
              payloadUpdate[jobGuid].loading = false
              payloadUpdate[jobGuid].error = e
              dispatch({
                type: ExportMapActions.START_JOB,
                payload: payloadUpdate
              })
            })
        })
        .catch(e => {
          console.error(e)
          this.restoreMap(mapZoomCache, mapCenterCache).then(() => {
            dispatch({
              type: MapActions.SET_HARD_LOADING,
              payload: false
            })
            hackCallback(e.message)
          })
        })
    }
  }
}
